import React, { useState, useEffect } from 'react'
import {
  Col,
  Panel,
  Row,
  Modal,
  Button,
  Icon,
  Message,
  Table,
  ControlLabel,
  Input,
  ButtonToolbar,
  Uploader,
} from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../../utils/loading'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import ConfirmWidget from '../../confirm/ConfirmWidget'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import {
  isImageOrPdf,
  isImageOrPdfOrMsFile,
  isValidators,
  requiredFiled,
} from '../../../utils/ValidatorUtils'
import notification from '../../../utils/notification'
import { isEmpty } from 'lodash-es'
import DownloadButton from '../../../components/buttons/downloadButton/downloadButton'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import {
  deleteDocumentManageIaFile,
  downloadDocumentManageIaFile,
  saveDocumentManageIa,
  searchDocumentManageIa,
} from '../../../redux/actions/IaDucumentManagement'
import {
  DEFAULT_ERR_MSG,
  DELETE_FILE_FAILED_MSG,
  DELETE_FILE_SUCCESS_MSG,
  SAVE_SUCCESS_MSG,
} from '../../../constants/msgText'
import { downloadFile } from '../../../utils/fileUtil'

export default function DucumentManagementWidget({ schema, ...props }) {
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const { Column, HeaderCell, Cell } = Table
  const [displayLength, setDisplayLength] = useState(25)
  const [page, setPage] = useState(1)
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [dataTable, setDataTable] = useState()
  const [isAddData, setIsAddData] = useState(false)
  const [isShowConfirmDelete, setIsShowConfirmDelete] = useState(false)
  const [rowId, setRowId] = useState()

  const twoCol = {
    first: {
      _lg: 12,
      _md: 12,
      _sm: 24,
      _xs: 24,
    },
    second: {
      _lg: 12,
      _md: 12,
      _sm: 24,
      _xs: 24,
    },
    full: {
      _lg: 24,
      _md: 24,
      _sm: 24,
      _xs: 24,
    },
  }

  useEffect(() => {
    console.log('scheeeee => ', schema.viewMode)
    // setDataTable(schema?.values || [])
    // onClearSearchFiles()
    callApiSearchFiles({ filesName: '' })
  }, [])

  const onSubmitSearchFiles = async (data) => {
    console.log('onSubmitSearchFiles => ', data)
    const request = {
      filesName: data?.documentName || '',
    }

    await callApiSearchFiles(request)
  }

  const onClearSearchFiles = async () => {
    onClearSearch()
    await callApiSearchFiles({ filesName: '' })
  }

  const onClearSearch = () => {
    setValue(schema?.searchForm?.documentName?.name, '')
    setValue(schema?.addForm?.documentName?.name, '')
    setValue(schema?.addForm?.attachFiles?.name, '')
    setValue(schema?.addForm?.note?.name, '')
  }

  const callApiSearchFiles = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await searchDocumentManageIa(request)
      console.log('ressss ooo => ', response)
      if (response) {
        setDataTable(response?.values || [])
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleAddForm = () => {
    setIsAddData(true)
    onClearSearchFiles()
  }

  const onSubmit = async (data) => {
    console.log('onSubmit => ', data)

    setIsLoading(true)
    startLoading()
    try {
      const formData = new FormData()
      formData.append('Id', data?.Id || '')
      formData.append('FileName', data?.documentName || '')
      formData.append('Note', data?.note || '')

      data.attachFiles &&
        data.attachFiles?.forEach((element) => {
          formData.append('FilePath', element.blobFile)
        })

      const response = await saveDocumentManageIa(formData)
      console.log('ressss ooo => ', response)
      if (response) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 5000,
        })

        setDataTable(response?.values || [])
        onClearSearch()
        setIsAddData(false)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        notification.open('error', {
          title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
          duration: 5000,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const onDownload = async (rowData) => {
    console.log('rowdtat => ', rowData)

    setIsLoading(true)
    startLoading()
    try {
      var file = await downloadDocumentManageIaFile(rowData.filePath)

      downloadFile(file, rowData?.fileName || rowData?.id)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const delFiles = async () => {
    // console.log('idddd => ', id)
    // return false
    setIsLoading(true)
    startLoading()
    try {
      // { id: rowId }
      const response = await deleteDocumentManageIaFile({ id: rowId })
      // console.log('ressss ooo => ', response)
      if (response.success) {
        notification.open('success', {
          title: DELETE_FILE_SUCCESS_MSG,
          duration: 5000,
        })
        // setDataTable(response?.values || [])
        onClearSearchFiles()
        setIsShowConfirmDelete(false)
      } else {
        notification.open('error', {
          title: DELETE_FILE_FAILED_MSG,
          duration: 5000,
        })
        setIsShowConfirmDelete(false)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        console.log('error', e)
        if (e?.response?.data) {
          notification.open('error', {
            title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
            duration: 5000,
          })
        } else {
          setError({})
        }
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  return (
    <>
      {isLoading && <OverlayLoader />}

      <Panel shaded collapsible defaultExpanded header={''} bordered>
        {/* ค้นหา */}
        {!isAddData ? (
          <>
            <div>
              <Panel
                collapsible
                defaultExpanded
                header={'ค้นหา'}
                bordered
                style={{ marginBottom: 10 }}
              >
                <Row>
                  <Col
                    lg={twoCol.first._lg}
                    md={twoCol.first._md}
                    sm={twoCol.first._sm}
                    xs={twoCol.first._xs}
                    style={{
                      marginTop: '5px',
                      padding: '8px',
                    }}
                  >
                    <ErrorMessage
                      error={errors[schema.searchForm.documentName.name]}
                      style={{ marginBottom: 10 }}
                    />
                    <ControlLabel>
                      {requiredFiled(
                        schema.searchForm.documentName.validators,
                        schema.searchForm.documentName.label
                      )}
                    </ControlLabel>

                    <Controller
                      name={schema.searchForm.documentName.name}
                      control={control}
                      defaultValue={schema.searchForm.documentName.value}
                      rules={isValidators(schema.searchForm.documentName.validators)}
                      render={(props) => {
                        return (
                          <Input
                            placeholder={schema.searchForm.documentName.label}
                            value={props.value}
                            // maxLength={getMaxLengthData(schema.searchForm.documentName.validators).value}
                            onChange={(value, e) => {
                              props.onChange(value)
                            }}
                            // disabled={!isVerification}
                          />
                        )
                      }}
                    />
                  </Col>
                  <Col
                    lg={twoCol.second._lg}
                    md={twoCol.second._md}
                    sm={twoCol.second._sm}
                    xs={twoCol.second._xs}
                    style={{
                      marginTop: '5px',
                      padding: '8px',
                    }}
                  >
                    <div style={{ marginTop: 25 }}>
                      <ButtonToolbar>
                        <SaveButton
                          style={{ minWidth: 120 }}
                          icon="search"
                          onClick={handleSubmit(onSubmitSearchFiles)}
                          disabled={isLoading}
                        >
                          {schema.searchForm.button.search}
                        </SaveButton>
                        <CancelButton
                          style={{ minWidth: 120 }}
                          disabled={isLoading}
                          onClick={() => {
                            onClearSearchFiles()
                          }}
                        >
                          {schema.searchForm.button.cancel}
                        </CancelButton>

                        {!schema.viewMode && (
                          <SaveButton
                            style={{ minWidth: 120 }}
                            icon="plus-square"
                            onClick={() => {
                              handleAddForm()
                            }}
                            disabled={isLoading}
                          >
                            เพิ่มแบบฟอร์ม
                          </SaveButton>
                        )}
                      </ButtonToolbar>
                    </div>
                  </Col>
                </Row>
              </Panel>

              {/* <div style={{ marginBottom: 5 }}>
                <SaveButton
                  style={{ minWidth: 120 }}
                  icon="plus-square"
                  onClick={() => {
                    setIsAddData(true)
                  }}
                  disabled={isLoading}
                >
                  เพิ่ม
                </SaveButton>
              </div> */}
            </div>
          </>
        ) : (
          <>
            <Panel
              collapsible
              defaultExpanded
              header={schema?.addForm?.title || ''}
              bordered
              style={{ marginBottom: 10 }}
            >
              <div style={{ marginBottom: 10 }}>
                <Row>
                  <Col
                    lg={twoCol.first._lg}
                    md={twoCol.first._md}
                    sm={twoCol.first._sm}
                    xs={twoCol.first._xs}
                  >
                    <ErrorMessage
                      error={errors[schema.addForm.documentName.name]}
                      style={{ marginBottom: 10 }}
                    />
                    <ControlLabel>
                      {requiredFiled(
                        schema.addForm.documentName.validators,
                        schema.addForm.documentName.label
                      )}
                    </ControlLabel>

                    <Controller
                      name={schema.addForm.documentName.name}
                      control={control}
                      defaultValue={schema.addForm.documentName.value}
                      rules={isValidators(schema.addForm.documentName.validators)}
                      render={(props) => {
                        return (
                          <Input
                            placeholder={schema.addForm.documentName.label}
                            value={props.value}
                            // maxLength={getMaxLengthData(schema.addForm.documentName.validators).value}
                            onChange={(value, e) => {
                              props.onChange(value)
                            }}
                            // disabled={!isVerification}
                          />
                        )
                      }}
                    />
                  </Col>
                  <Col
                    lg={twoCol.second._lg}
                    md={twoCol.second._md}
                    sm={twoCol.second._sm}
                    xs={twoCol.second._xs}
                  >
                    <ErrorMessage
                      error={errors[schema.addForm.note.name]}
                      style={{ marginBottom: 10 }}
                    />
                    <ControlLabel>
                      {requiredFiled(schema.addForm.note.validators, schema.addForm.note.label)}
                    </ControlLabel>

                    <Controller
                      name={schema.addForm.note.name}
                      control={control}
                      defaultValue={schema.addForm.note.value}
                      rules={isValidators(schema.addForm.note.validators)}
                      render={(props) => {
                        return (
                          <Input
                            placeholder={schema.addForm.note.label}
                            value={props.value}
                            // maxLength={getMaxLengthData(schema.addForm.note.validators).value}
                            onChange={(value, e) => {
                              props.onChange(value)
                            }}
                            // disabled={!isVerification}
                          />
                        )
                      }}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col
                    lg={twoCol.full._lg}
                    md={twoCol.full._md}
                    sm={twoCol.full._sm}
                    xs={twoCol.full._xs}
                    style={{
                      marginTop: '5px',
                      padding: '8px',
                    }}
                  >
                    <ErrorMessage
                      error={errors[schema?.addForm?.attachFiles?.name]}
                      style={{ marginBottom: 10 }}
                    />

                    <ControlLabel>
                      {requiredFiled(
                        schema.addForm.attachFiles.validators,
                        schema.addForm.attachFiles.header
                      )}
                    </ControlLabel>

                    {schema?.addForm?.attachFiles?.fileType && (
                      <Message
                        style={{ marginTop: 10, marginBottom: 10 }}
                        showIcon
                        type="info"
                        description={`ชนิดที่รองรับ ${
                          schema?.addForm?.attachFiles?.fileType || '.docx, .pptx, .xlsx, .pdf'
                        } และขนาดไฟล์ไม่เกิน ${schema?.addForm?.attachFiles?.fileSize || 50} MB`}
                      />
                    )}

                    <Controller
                      name={schema?.addForm?.attachFiles?.name}
                      control={control}
                      defaultValue={undefined}
                      rules={isValidators(schema?.addForm?.attachFiles?.validators)}
                      render={(props) => {
                        return (
                          <Uploader
                            accept={
                              schema?.addForm?.attachFiles?.fileType || '.docx, .pptx, .xlsx, .pdf'
                            }
                            draggable
                            autoUpload={false}
                            multiple={false}
                            fileListVisible={true}
                            fileList={props.value || []}
                            onChange={(fileList) => {
                              if (isEmpty(fileList)) {
                                props.onChange(undefined)
                              } else {
                                let file = fileList[fileList.length - 1]

                                if (
                                  file.blobFile.size >
                                  (schema.addForm?.attachFiles?.fileSize || defaultMaxFileSize) *
                                    1024 *
                                    1024
                                ) {
                                  notification.open('error', {
                                    title: `ขนาดไฟล์เกิน ${
                                      schema.addForm.attachFiles.fileSize || defaultMaxFileSize
                                    } MB`,
                                    duration: 5000,
                                  })
                                  return
                                }

                                if (isImageOrPdfOrMsFile(file.blobFile.type)) {
                                  let files = []
                                  files.push(fileList[fileList.length - 1])
                                  props.onChange(files)

                                  // props.onChange(fileList)
                                  //setFileTypeError(false)
                                } else {
                                  //setFileTypeError(true)
                                  notification.open('error', {
                                    title:
                                      'ชนิดที่รองรับ ' + schema.addForm.attachFiles.fileType ||
                                      '.docx, .xlsx, .pdf',
                                    duration: 5000,
                                  })
                                }
                              }
                            }}
                          >
                            <div style={{ lineHeight: '100px' }}>
                              <Icon size="4x" icon="upload2" />
                              <small
                                style={{
                                  marginTop: '-70px',
                                  display: 'block',
                                  whiteSpace: 'nowrap',
                                  textOverflow: 'ellipsis',
                                }}
                              >
                                คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด
                              </small>
                            </div>
                          </Uploader>
                        )
                      }}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col
                    lg={twoCol.full._lg}
                    md={twoCol.full._md}
                    sm={twoCol.full._sm}
                    xs={twoCol.full._xs}
                    style={{
                      textAlign: 'right',
                    }}
                  >
                    <div style={{ marginTop: 25 }}>
                      <ButtonToolbar>
                        <SaveButton
                          style={{ minWidth: 120 }}
                          onClick={handleSubmit(onSubmit)}
                          disabled={isLoading}
                        >
                          {schema.addForm.button.save}
                        </SaveButton>
                        <CancelButton
                          style={{ minWidth: 120 }}
                          disabled={isLoading}
                          onClick={() => {
                            setIsAddData(false)
                          }}
                        >
                          {schema.addForm.button.cancel}
                        </CancelButton>
                      </ButtonToolbar>
                    </div>
                  </Col>
                </Row>
              </div>
            </Panel>
          </>
        )}

        <Table wordWrap height={400} loading={isLoading} data={dataTable}>
          <Column align="center" width={100} fixed>
            <HeaderCell>ลำดับ</HeaderCell>
            <Cell>
              {(_, index) => {
                return index + 1 + (page * displayLength - displayLength)
              }}
            </Cell>
          </Column>

          <Column flexGrow={2}>
            <HeaderCell>ชื่อ</HeaderCell>
            {/* <Cell dataKey="fileName" /> */}
            <Cell>
              {(rowData) => {
                if (rowData?.filePath?.split('.')?.length == 2) {
                  // console.log('rowData => ', rowData.filePath.split('.')[1])
                  let iconName = 'file-text-o'
                  let iconColor = '#000'
                  switch (rowData.filePath.split('.')[1]) {
                    case 'docx':
                      iconName = 'file-word-o'
                      iconColor = '#0088ff'
                      break

                    case 'xlsx':
                      iconName = 'file-excel-o'
                      iconColor = '#217346'
                      break

                    case 'pdf':
                      iconName = 'file-pdf-o'
                      iconColor = '#ee0d0d'
                      break

                    case 'pptx':
                      iconName = 'file-powerpoint-o'
                      iconColor = '#D04423'
                      break

                    default:
                      break
                  }
                  return (
                    <div>
                      <Icon
                        icon={iconName}
                        style={{ marginRight: 10, color: iconColor }}
                        size="lg"
                      />
                      {`${rowData.fileName}.${rowData.filePath.split('.')[1]}`}
                    </div>
                  )
                }

                return rowData.fileName
              }}
            </Cell>
          </Column>

          <Column flexGrow={1}>
            <HeaderCell>หมายเหตุ</HeaderCell>
            <Cell dataKey="note" />
          </Column>

          <Column width={300} align="center">
            <HeaderCell>#</HeaderCell>
            <Cell>
              {(rowData) => {
                return (
                  <>
                    <ButtonToolbar>
                      <DownloadButton
                        // disabled={!schema?.assetCountAttach?.values[0].path}
                        children="โหลดไฟล์"
                        isabled={isLoading}
                        size="sm"
                        onClick={() => {
                          // onDownload(schema?.assetCountAttach?.values[0].path)
                          onDownload(rowData)
                        }}
                      />

                      {!schema.viewMode && (
                        <CancelButton
                          disabled={isLoading}
                          icon="trash"
                          size="sm"
                          children="ลบไฟล์"
                          onClick={() => {
                            // delFiles(rowData.id)
                            setRowId(rowData.id)
                            setIsShowConfirmDelete(true)
                          }}
                        />
                      )}
                    </ButtonToolbar>
                  </>
                )
              }}
            </Cell>
          </Column>
        </Table>
      </Panel>

      <ConfirmWidget
        title={'ยืนยันลบเอกสาร'}
        show={isShowConfirmDelete}
        //detail={'ยืนยันลบเอกสาร'}
        onCancle={() => setIsShowConfirmDelete(false)}
        onConfirm={delFiles}
      />
    </>
  )
}
